import React from "react";

import { UnsubscribePayload, UnsubscribeResult, unsubscribeSubscribers } from "@admin/api/announcements";

export const useUnsubscribeSubscribers = () => {
    const [isLoading, setIsLoading] = React.useState(false);

    const onUnsubscribe = async (payload: UnsubscribePayload): Promise<UnsubscribeResult> => {
        setIsLoading(true);
        try {
            return await unsubscribeSubscribers(payload);
        } finally {
            setIsLoading(false);
        }
    };

    return { isLoading, onUnsubscribe };
};
